// src/features/treatments/MainMenu/OPD/treatment-course.utils.ts
// Sequence rules for using a patient's treatment course: items carrying an
// itemSort must be used in order, so only the earliest sequence item that
// still has balance can be added (MJ-2607-0460). Pure so it is unit-testable.

export interface CourseSequenceItem {
  itemSort?: number | null
  balance: number
  /** Balance after subtracting items already placed in the treatment summary. */
  lastBalance?: number
}

const remaining = (i: CourseSequenceItem): number => Math.max(i.lastBalance ?? i.balance ?? 0, 0)

/** Lowest itemSort among sequenced items with balance left, or null when the course is used up. */
export function nextCourseItemSort(items: CourseSequenceItem[]): number | null {
  const open = items.filter((i) => i.itemSort != null && i.itemSort > 0 && remaining(i) > 0)
  if (open.length === 0) return null
  return Math.min(...open.map((i) => i.itemSort as number))
}

export function isCourseItemSelectable(item: CourseSequenceItem, items: CourseSequenceItem[]): boolean {
  if (remaining(item) <= 0) return false
  if (item.itemSort == null || item.itemSort <= 0) return true
  const next = nextCourseItemSort(items)
  return next != null && item.itemSort <= next
}
